import { Trans } from '@lingui/macro'
import {
  Button,
  Dialog,
  DialogContent,
  Grid
} from '@mui/material'
import React, { ReactNode, useEffect } from 'react'
import { DialogTitleWithIconClose } from '../common-components/DialogTitleWithIconClose'

export interface PopUpDialogueProps {
  dialogTitle?: string | JSX.Element
  dialogMessege?: string | JSX.Element
  type?: 'ok' | 'okCancel'
  displayAlt?: boolean
  altMessege?: string
  altHandle?: () => void
  altText?: string
  open?: boolean
  closeFunction: (() => void)
  cancelFunction?: (() => void)
  confirmFunction?: (() => void)
  okText?: ReactNode
  cancelText?: ReactNode
}

const PopUpDialogue: React.FC<PopUpDialogueProps> = ({
  dialogTitle,
  dialogMessege,
  type = 'ok',
  displayAlt,
  altMessege,
  altHandle,
  altText,
  open = true,
  closeFunction,
  cancelFunction = null,
  confirmFunction = null,
  okText = <Trans>Ok</Trans>,
  cancelText = <Trans>Cancel</Trans>
}) => {
  const [isOpened, setOpen] = React.useState(open)

  useEffect(() => {
    if (open) {
      setOpen(true)
    }
  }, [open])

  return (
    <Dialog
      open={isOpened}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitleWithIconClose
        label={dialogTitle}
        handleClose={e => {
          setOpen(false)
          closeFunction()
        }}
      />
      <DialogContent>
        {displayAlt != null ? altMessege : dialogMessege}
        <Grid
          container
          direction='column'
          sx={{ mt: '16px' }}
          gap='8px'
        >
          <Button
            variant='contained'
            color='primary'
            fullWidth
            onClick={() => {
              setOpen(false)
              if (confirmFunction != null) {
                confirmFunction()
              } else if (closeFunction != null) {
                closeFunction()
              }
            }}
          >
            {okText}
          </Button>
          {type === 'okCancel' && (
            <Button
              fullWidth
              variant='outlined'
              color='primary'
              onClick={() => {
                setOpen(false)
                if (cancelFunction != null) {
                  cancelFunction()
                } else if (closeFunction != null) {
                  closeFunction()
                }
              }}
            >
              {cancelText}
            </Button>
          )}
          {displayAlt != null && (
            <Button
              fullWidth
              variant='contained'
              color='primary'
              onClick={() => {
                setOpen(false)
                if (altHandle != null) {
                  altHandle()
                }
              }}
            >
              {altText}
            </Button>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default PopUpDialogue
